import { render, staticRenderFns } from "./Inquiries.vue?vue&type=template&id=6b10bf22&scoped=true"
import script from "./Inquiries.vue?vue&type=script&lang=ts"
export * from "./Inquiries.vue?vue&type=script&lang=ts"
import style0 from "./Inquiries.vue?vue&type=style&index=0&id=6b10bf22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b10bf22",
  null
  
)

export default component.exports